import axios from 'axios'
import { useIdpAuth } from '../composables/useIdpAuth'

const admin = axios.create({
  baseURL:
    import.meta.env.VITE_APP_LOCALHOST === 'true'
      ? '/api'
      : import.meta.env.VITE_API_URL,
  timeout: 300000, // 5 минут для больших файлов
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
})

admin.interceptors.response.use(
  response => {
    if (response?.data?.ok === false) {
      const error = new Error(response.data?.data?.message || 'Ошибка запроса')
      error.response = response
      return Promise.reject(error)
    }
    return response
  },
  error => handleAuthError(error)
)

const handleAuthError = error => {
  if (error.response?.status === 401) {
    const { redirectToIdp } = useIdpAuth()

    redirectToIdp('login', window.location.href)
  }

  return Promise.reject(error)
}

class ApiService {
  constructor(entityPath) {
    this.entityPath = entityPath
  }

  async getList(params = {}) {
    const response = await admin.get(`/${this.entityPath}`, { params })
    return response.data
  }

  async update(id, payload) {
    const response = await admin.patch(`/${this.entityPath}/${id}`, payload)
    return response.data
  }

  async action(id, payload) {
    const response = await admin.post(`/${this.entityPath}/${id}`, payload)
    return response.data
  }

  async subAction(id, subPath, payload) {
    const response = await admin.post(
      `/${this.entityPath}/${id}/${subPath}`,
      payload
    )
    return response.data
  }
}

class ReportingService {
  async getSpaceReports(spaceId, params = {}) {
    const response = await admin.get(
      `/reporting/spaces/${spaceId}/reports/platform.audit_log`,
      {
        params
      }
    )
    return response.data
  }
}

export const projectsApi = new ApiService('admin/projects')
export const reportingApi = new ReportingService()
